import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { RouteConfig } from '@/types/route';
import { PageLink } from '@/config/pageConfig';

interface PermissionRouteProps {
  route: RouteConfig;
  permissionRoutes: RouteConfig[];
}

/**
 * 检查路径是否匹配（支持动态参数）
 */
const isPathMatch = (permissionPath: string, currentPath: string): boolean => {
  const permissionSegments = permissionPath.split('/').filter(Boolean);
  const currentSegments = currentPath.split('/').filter(Boolean);

  if (permissionPath.includes('9')) {
    debugger;
  }
  // 如果段数不同且权限路径不包含参数，则不匹配
  if (permissionSegments.length !== currentSegments.length) {
    return false;
  }

  // 逐段比较
  const matched = permissionSegments.every((permSegment, index) => {
    const currSegment = currentSegments[index];
    // 如果是参数段（以 : 开头），则视为匹配
    if (permSegment.startsWith(':')) {
      return true;
    }
    // 否则必须完全相等
    return permSegment === currSegment;
  });

  return matched;
};

/**
 * 递归检查路由权限
 */
const checkRoutePermission = (
  currentPath: string,
  routes: RouteConfig[]
): boolean => {
  for (const route of routes) {
    // 检查当前路由是否匹配
    if (route.path && isPathMatch(route.path, currentPath)) {
      return true;
    }

    // 递归检查子路由
    if (route.children?.length) {
      if (checkRoutePermission(currentPath, route.children)) {
        return true;
      }
    }
  }

  return false;
};

const PermissionRoute: React.FC<PermissionRouteProps> = ({
  route,
  permissionRoutes,
}) => {
  const location = useLocation();

  // 如果路由不需要权限，直接渲染
  if (route.noPermissionRequired) {
    return route.element;
  }

  // 使用实际访问的路径（location.pathname）来检查权限
  const hasPermission = checkRoutePermission(
    location.pathname,
    permissionRoutes
  );

  if (!hasPermission) {
    // 如果没有权限，重定向到 403 页面，并保存原始路径

    return (
      <Navigate
        to={PageLink.NoPermission}
        state={{ from: location.pathname }}
        replace
      />
    );
  }

  return route.element;
};

export default PermissionRoute;
